import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
/**
 * Text
 */
const Suggest = ({ boxStyle, item, viewType,onClickEvt }) => {
  const { items, type, id } = item;
  console.log(items)
  return (
    <>
      <div className="_suggests_div">
        {items !== undefined &&
          items.map((tempItem, idx) => {
            return (
              <div className="_suggest_area" key={`${id}_${idx}_area`}>
              <div key={`${id}_${idx}`} className="_button" style={boxStyle} onClick={e => onClickEvt(tempItem.button.value, 'query')}>
                {ReactHtmlParser(tempItem?.button?.label || '')}
              </div>
            </div>
            );
          })}
      </div>
    </>
  );
};
Suggest.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
Suggest.defaultProps = {
  boxStyle: {},
  item: {},
  onClickEvt: null,
  viewType: 'advise', // advise, simulator, knowledge
};

export default Suggest;
